// import { capitalize } from '../../views/utils'

// const store = {
//   $infix: 'stats',
//   range: [30],
//   workers: [[]],
//   invoiceStatus: [[]],
// }

// function buildBasicStore({ $infix, ...store }) {
//   const keys = Object.keys(store)
//   const buildName = (stateKey, actionName = 'SET') => [actionName, $infix, stateKey]
//     .filter(str => str)
//     .map(str => str.toUpperCase())
//     .join('_')

//   const basicState = keys
//     .reduce((acc, stateKey) => ({
//       ...acc,
//       [stateKey]: store[stateKey][0],
//     }), {})
//   const basicActions = keys
//     .map(buildName)
//     .reduce((acc, actionName) => ({
//       ...acc,
//       [actionName]: ({ commit }, value) => {
//         commit(actionName, value)
//       },
//     }), {})
//   const basicMutations = keys
//     .reduce((acc, stateKey) => {
//       const name = buildName(stateKey)
//       return {
//         [name]: (state, value) => {
//           state[stateKey] = value
//         },
//         ...acc,
//       }
//     }, {})

//   const basicGetters = keys
//     .reduce((acc, stateKey) => {
//       const name = $infix
//         ? `${$infix + capitalize(stateKey)}`
//         : stateKey
//       return {
//         [name]: state => state[stateKey],
//         ...acc,
//       }
//     }, {})

//   return {
//     basicActions,
//     basicGetters,
//     basicMutations,
//     basicState,
//   }
// }

export default {
  storeKey: 'stats',
  store: {
    state: {
      range: 30,
      workers: null,
      invoiceStatuses: null,
    },
    actions: {
      SET_STATS_RANGE({ commit }, range) {
        commit('SET_STATS_RANGE', range)
      },
      SET_STATS_WORKERS({ commit }, workersIds) {
        commit('SET_STATS_WORKERS', workersIds)
      },
      SET_STATS_INVOICE_STATUSES({ commit }, invoiceStatuses) {
        commit('SET_STATS_INVOICE_STATUSES', invoiceStatuses)
      },
    },
    mutations: {
      SET_STATS_RANGE(state, range) {
        state.range = range
      },
      SET_STATS_WORKERS(state, workerIds) {
        state.workers = workerIds
      },
      SET_STATS_INVOICE_STATUSES(state, invoiceStatuses) {
        state.invoiceStatuses = invoiceStatuses
      },
    },
    getters: {
      statsRange: state => state.range,
      statsInvoiceStatuses: state => state.invoiceStatuses,
      statsWorkers: state => state.workers,
      rangeOptions: () => [
        { name: 'Past 30 days', value: 30 },
        { name: 'Past 7 days', value: 7 },
        { name: 'This month', value: new Date().getDate() },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/stats.js